import { useEffect } from 'react';

export const useCustomScript = ({ url }: { url: string | undefined }) => {
    useEffect(() => {
        if (url) {
            const script = document.createElement('script');
            script.src = url;
            script.async = true;
            document.body.appendChild(script);
            return () => {
                document.body.removeChild(script);
            };
        }
    }, [url]);
};
